import EditExternalEmployees from "./EditExternalEmployees.jsx";
export default EditExternalEmployees;